var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.5H6.5C6.5 10.04 7.185 10.5 8 10.5C8.815 10.5 9.5 10.04 9.5 9.5C9.5 8.95 8.98 8.75 7.88 8.485C6.82 8.22 5.5 7.89 5.5 6.5C5.5 5.605 6.235 4.845 7.25 4.59V3.5H8.75V4.59C9.765 4.845 10.5 5.605 10.5 6.5H9.5C9.5 5.96 8.815 5.5 8 5.5C7.185 5.5 6.5 5.96 6.5 6.5C6.5 7.05 7.02 7.25 8.12 7.515C9.18 7.78 10.5 8.11 10.5 9.5C10.5 10.395 9.765 11.155 8.75 11.41V12.5H7.25V11.41C6.235 11.155 5.5 10.395 5.5 9.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/money-icon.e4714953.svg";
export { ForwardRef as ReactComponent };